export default __webpack_public_path__ + "static/media/bundle.198a3754.png";